import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfigurationService } from '@core/services';

/**
 * In-content footer, mirroring PMP's own "Minimal" footer. Rendered inside a
 * page's own scroll container (checkout,
 * summary) rather than as app chrome — the fixed bottom bar
 * (`app-sticky-progress-bar`) owns the viewport bottom edge.
 *
 * `Configuration` has no dedicated privacy-policy URL, so "Privacy Policy"
 * points at `termsOfUseUrl` and "Terms of Service" at `termsAndConditionsUrl`
 * — both already exist on the model, nothing new added.
 */
@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  public configurationService = inject(ConfigurationService);

  readonly currentYear = new Date().getFullYear();
}
